/** Official W Group logo. `light` renders the ivory variant for dark backgrounds. */
export const Logo = ({ light = false }: { light?: boolean }) => (
  <img
    src={light ? "/wgroup-logo-light.webp" : "/wgroup-logo.webp"}
    alt="W Group"
    width={2000}
    height={667}
    className="h-9 w-auto sm:h-10"
    data-testid="brand-logo"
  />
);
